// extracted by mini-css-extract-plugin
export var alignLeft = "m_qh d_fp d_bG d_dv";
export var alignCenter = "m_bP d_fq d_bD d_dw";
export var alignRight = "m_qj d_fr d_bH d_dx";
export var customRow = "m_qb d_bD d_Z";